import React, { FunctionComponent } from 'react';
import styles from './award.module.scss';
import { Fade } from 'react-awesome-reveal';

export interface IImage {
  url: string;
  description: string;
}
export interface IAwardProps {
  header: string;
  description: string;
  images: IImage[];
  isActive?: boolean;
}

export const Award: FunctionComponent<IAwardProps> = ({
  header,
  description,
  images,
  isActive
}) => {
  return (
    <Fade triggerOnce>
      <div className={`${styles.container} ${isActive && styles.active}`}>
        <div className={styles.awardWrapper}>
          <div className={styles.imageWrapper}>
            {images.map(image => (
              <img
                key={image.url}
                className={styles.image}
                src={image.url}
                alt={image.description}
              />
            ))}
          </div>
        </div>
        <div className={styles.awardInfo}>
          <h3 className={styles.header}>{header}</h3>
          <p className={styles.description}>{description}</p>
        </div>
      </div>
    </Fade>
  );
};
